<template>
  <button class="cursor-pointer rounded-md bg-gray px-2 py-2">
    <slot />
  </button>
</template>
